import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  getStripePrices,
  setCurrentStripePrice,
  register, setBillingType, setRegisterData,
  // setBillingType,
} from 'modules/auth/actions';
import { dispatch } from 'store';
import { Button } from 'views/components';
import { RootState } from 'types';

import { t } from 'utils';
import { InfoBlock } from '../../components/InfoBlock';
import { PrevStep } from '../../components/PrevStep';

import styles from './ThirdStep.module.css';
import texts from '../../../texts';
import textsPlan from '../../../../../../pages/Plan/texts';

export const ThirdStepClinic: FC = () => {
  // store
  const { registerData, stripePrices, errors } = useSelector((state: RootState) => state.auth);
  const { currentCountry } = useSelector((state: RootState) => state.app);
  const { currencyType, countriesList } = useSelector((state: RootState) => state.user);

  const stripePricesMonthly: any = [];
  // const stripePricesAnnual: any = [];

  // stripePrices.map(el => {
  //   if (el.billing_type === 'monthly') {
  //     stripePricesMonthly.push(el);
  //   } else {
  //     stripePricesAnnual.push(el);
  //   }
  // });

  stripePrices.map(el => {
    if (el.billing_type === 'monthly') {
      stripePricesMonthly.push(el);
    }
  });

  // const billingTypeAnnual = registerData.billingType === 'Annual';

  useEffect(() => {
    currencyType && dispatch(getStripePrices.request());
  }, [currencyType]);

  // useEffect(() => {
  //   if (!registerData.currentStripePrice && stripePrices.length > 0) {
  //     dispatch(setCurrentStripePrice(stripePricesAnnual[0]));
  //   }
  // }, [stripePrices, registerData]);

  useEffect(() => {
    if (!registerData.currentStripePrice && stripePrices.length > 0) {
      dispatch(setCurrentStripePrice(stripePricesMonthly[0]));
    }
    if(registerData.billingType === 'monthly') {
      dispatch(setBillingType('monthly'))
    }

  }, [stripePrices, registerData]);

  const handleSubmit = () => {   
      const findedArr = countriesList.filter(i => i.short_name === currentCountry);
      if(findedArr && findedArr.length) {
       dispatch(setRegisterData('country', `${findedArr[0].id}`));
      }
      dispatch(register.request(false));
  };

  const handleInputChange = (event: any) => {
    const { value } = event.target;
    const item = stripePrices.find(el => el.nickname === value) || null;
    dispatch(setCurrentStripePrice(item));
  };

  const renderError = () => {
    for (let key in errors) {
      return <p style={{ color: 'red', fontSize: '12px' }}>{errors[key]}</p>;
    }
  };

  return (
    <div className={styles.container}>
      <PrevStep step={3} />
      <div className={styles.content}>
        <div>
          {renderError()}
          <h1>{t(texts.clinicThirdStepTitle)}</h1>
          {currencyType ? (
            <div className={styles.order}>
              <div style={{ marginBottom: '20px' }}>
                <p style={{ fontSize: '12px' }}>{t(texts.clinicThirdStepPlanType)}</p>

                <div style={{ display: 'flex' }}>
                <div>
                  <label htmlFor="contactChoice1">{t(textsPlan.plan.monthly)}</label>
                  <input
                    style={{ width: '10px', marginRight: '20px' }}
                    id="contactChoice1"
                    type="radio"
                    checked={String(registerData.billingType).toLowerCase() === 'monthly'}
                    value="monthly"
                    onClick={() => {
                      dispatch(setCurrentStripePrice(stripePricesMonthly[0]));
                      dispatch(setBillingType('monthly'));
                    }}
                  />
                </div>
                {/* <div>
                  <label htmlFor="contactChoice2">{t(textsPlan.plan.payPerClick)}</label>
                  <input
                    style={{ width: '10px' }}
                    id="contactChoice2"
                    type="radio"
                    checked={registerData.billingType === 'ppc'}
                    value="ppc"
                    onClick={() => {
                      dispatch(setCurrentStripePrice(stripePricesMonthly[0]));
                      dispatch(setBillingType('ppc'));
                    }}
                  />
                </div> */}
              </div>

              </div>
              <select className={styles.main} onChange={handleInputChange}>
                {stripePricesMonthly.map((el: any, i: number) => (
                  <option
                    key={el.nickname}
                    value={el.nickname}
                    selected={registerData?.currentStripePrice?.nickname === el.nickname}
                  >
                    {el.nickname}
                  </option>
                ))}
              </select>
              {/* <select className={styles.main} onChange={handleInputChange}>
              {billingTypeAnnual
                ? stripePricesAnnual.map((el: any) => (
                    <option
                      key={el.nickname}
                      value={el.nickname}
                      selected={registerData?.currentStripePrice?.nickname === el.nickname}
                    >
                      {el.nickname}
                    </option>
                  ))
                : stripePricesMonthly.map((el: any, i: number) => (
                    <option
                      key={el.nickname}
                      value={el.nickname}
                      selected={registerData?.currentStripePrice?.nickname === el.nickname}
                    >
                      {el.nickname}
                    </option>
                  ))}
            </select> */}
              <p style={{ fontSize: '22px', fontWeight: 'bold' }}>
                {t(texts.clinicThirdStepFreeTrial)}
              </p>
            </div>
          ) : (
            <>
              <p style={{ fontStyle: 'italic' }}>Loading ...</p>
            </>
          )}
        </div>
        {currencyType && (
          <div className={styles.infoBlockWrap}>
            <InfoBlock numberOfMachines={registerData.currentStripePrice?.number_of_machines} />
          </div>
        )}
      </div>

      {currencyType && (
        <div className={styles.buttonWrap}>
          <Button
            title={t(texts.clinicThirdStepButtonText)}
            onClick={handleSubmit}
          />
        </div>
      )}
    </div>
  );
};
